// Web-only stub for react-native-maps.
// The app renders maps on web via @vis.gl/react-google-maps (see *.web.tsx variants),
// so the native react-native-maps package must never be evaluated in the browser.
// Importing the real package on web crashes with "codegenNativeComponent is not a function".
module.exports = new Proxy(
  { default: undefined },
  {
    get: () => undefined
  }
);